import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  { number: '10', suffix: '間', label: '青年公寓成立' },
  { number: '39', suffix: '次', label: '發起青年行動' },
  { number: '40', suffix: '位', label: '青年學校培育者' },
  { number: '2,000', suffix: '＋', label: '受益人數' },
];

const StatsRow = () => {
  return (
    <section className="py-20 bg-teal-600 relative overflow-hidden">
      {/* Abstract background pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            我們是培力影響力世代的社會設計團隊
          </h2>
          <p className="text-teal-100 text-lg max-w-3xl mx-auto">
            成為青年影響力人才的搖籃，打造跨世代、跨國界的影響力社群，培養志同道合的青年夥伴，拓展海內外社會創新視野，在所在社區創造看得見的改變。
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divider-x divider-teal-500/50">
          {stats.map((stat, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center flex flex-col items-center justify-center relative"
            >
              {index !== 0 && (
                <div className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 w-px h-16 bg-teal-500/50" />
              )}
              <div className="flex items-baseline justify-center gap-1 mb-2">
                <span className="text-5xl md:text-6xl font-black text-white">{stat.number}</span>
                <span className="text-2xl font-bold text-teal-200">{stat.suffix}</span>
              </div>
              <span className="text-teal-100 font-medium text-lg">{stat.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsRow;